import React, { FC } from 'react'
import { IFlex } from '@ads/front-ds'
import Errors from '@ads/front-core/components/Errors'
import {
  ErrorBoxSize,
  Variant,
} from '@ads/front-core/components/Errors/interfaces'
import { Trans, TTranslationsKeys } from '@ads/front-core/locales'

interface IWarningBox {
  i18nKey?: TTranslationsKeys
  components?:
    | readonly React.ReactElement[]
    | { readonly [tagName: string]: React.ReactElement }
  values?: Record<string, string | number>
}

export const WarningBox: FC<IWarningBox & IFlex> = ({
  i18nKey,
  components,
  values,
  ...restFlex
}) => (
  <Errors
    errors={[
      {
        variant: Variant.WARNING,
        items: [
          {
            Message: (
              <Trans
                i18nKey={i18nKey}
                components={components}
                values={values}
              />
            ),
          },
        ],
      },
    ]}
    boxSize={ErrorBoxSize.MEDIUM}
    {...restFlex}
  />
)
